import { FC } from "react";
import { Flex, Box } from "@chakra-ui/react";
import SkeletonBox from "../SkeletonBox";
import SkeletonCategorySelection from "../SkeletonCategorySelection";
import SkeletonTabs from "../SkeletonTabs";
import SkeletonPageFrame from "./SkeleteonPageFrame";
import SkeletonPageTitle from "../SkeletonPageTitle";

const SkeletonCategorySelectionPage: FC = () => (
  <SkeletonPageFrame>
    <SkeletonPageTitle />

    <Flex
      gap={[12, null, 16]}
      flexDirection={["column", null, "row"]}
      justifyContent="space-between"
    >
      <Box flex="1 0 auto">
        <SkeletonTabs mb={8} />
        <SkeletonCategorySelection />
      </Box>

      <Flex flexDirection="column" gap={3} w="100%" maxWidth={400}>
        <SkeletonBox h={150} w="100%" borderRadius={10} />
        <SkeletonBox h={200} w="100%" borderRadius={10} />
      </Flex>
    </Flex>
  </SkeletonPageFrame>
);

export default SkeletonCategorySelectionPage;
